import { forwardRef } from "react";
import { css, styled } from "goober";
import { tablet } from "clutch/src/Style/style.mjs";

import Container from "@/shared/ContentContainer.jsx";

// export const MatchContainer = () => css`
//   display: flex;
//   flex-direction: column;
//   gap: var(--sp-4);
// `;

export const Subtitle = styled("p")`
  display: flex;
  gap: var(--sp-3);
  color: var(--shade2);
  white-space: nowrap;
`;

export const MatchPageContainer = styled("div")`
  display: grid;
  gap: var(--sp-4);
  max-width: var(--sp-container);
  width: 100%;
  margin-inline: auto;
`;

export const MainColumnsContainer = styled(Container)`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--sp-4);

  :where(&) > * {
    display: grid;
    grid-template-rows: max-content;
    gap: var(--sp-4);
  }

  .span-1 {
    grid-column: span 1;
  }
  .span-2 {
    grid-column: span 2;
  }
  .span-3,
  .span-all {
    grid-column: 1 / -1;
  }

  ${tablet} {
    display: flex;
    flex-direction: column;
  }
`;

export const MatchLayoutContainer = styled(Container, forwardRef)`
  display: grid;
  gap: var(--sp-4);
`;

export const MatchHeaderContainer = () => css`
  display: flex;
  align-items: center;
  gap: var(--sp-4);
  max-width: var(--sp-container);
  margin-inline: auto;
  width: 100%;
  z-index: 3;

  > .left {
    flex: 1;
    display: grid;
    gap: var(--sp-3);
  }
`;

export const MatchTile = styled("div", forwardRef)`
  padding: var(--sp-5);
`;

export const MatchTileEmptyContainer = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 2rem;
    height: 2rem;
  }
`;

export const MatchLink = styled("a")`
  display: block;
  inset: 0;
  transition: background-color var(--transition);

  &:hover {
    background: var(--shade3-15);
  }
`;

export const MatchStatContainer = styled("div")`
  container-type: inline-size;
  container-name: match-stats;
`;

export const StatBox = styled("div")`
  position: relative;
  background: var(--shade8);
  border-radius: var(--br-lg);
  padding: var(--sp-6);
  padding-block-start: var(--sp-8);
  box-shadow: inset 0 0 0 1px var(--shade3-15);
  overflow: hidden;

  &[data-no-score="true"],
  &[data-disabled="true"] {
    .stat-value {
      opacity: 0.25;
    }
  }

  &[data-disabled="true"] {
    .character-img {
      opacity: 0.5;
      filter: saturate(0.5);
    }
    .bg-img {
      img {
        filter: blur(3px) saturate(0) !important;
      }
    }
  }

  > * {
    position: relative;
  }

  &.character {
    padding: var(--sp-5);

    .bg-img {
      position: absolute;
      top: 0;
      left: 50%;
      width: 100%;
      aspect-ratio: 1;
      translate: -50% -20%;
      -webkit-mask-image: radial-gradient(
        circle at top center,
        black,
        transparent 80%
      );

      img {
        width: 100%;
        opacity: 0.15;
        filter: blur(3px) saturate(1.5);
      }
    }

    .character-value {
      display: block;
      text-align: center;
      margin-top: -1.5rem;
    }
    .disabled-text {
      display: block;
      text-align: center;
      padding-block-start: var(--sp-4);
      color: var(--shade1);
    }
  }

  .corner-img {
    position: absolute;
    top: var(--sp-3);
    left: var(--sp-3);
    width: var(--sp-6);
    height: var(--sp-6);
    background-image: var(--bg-img);
    background-size: calc(var(--bg-img-size) * 1%);
    background-position: center;
    border-radius: var(--br);
  }
`;

export const CategoryInsights = styled("div")`
  display: grid;
  gap: var(--sp-2);
  padding-block-start: var(--sp-3);

  .category-insight {
    display: grid;
    gap: var(--sp-2);

    header {
      display: flex;
      align-items: center;
      gap: var(--sp-2);
    }
    .title {
      white-space: nowrap;
    }
    .tags {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: var(--sp-1);
      color: var(--shade1);
    }
    .tag {
      white-space: nowrap;
      padding-inline: var(--sp-1);
      background: var(--shade1-15);
      border-radius: var(--br-sm);

      span {
        display: block;
      }
    }
    .line-items {
      display: grid;
      gap: var(--sp-2);
      list-style: disc;
      padding-inline-start: var(--sp-5);
      color: var(--shade1);
    }
  }
`;

export const TabsContainer = styled("div")`
  container-type: inline-size;
  container-name: tabs;
  display: flex;

  .tab {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--shade8);
    padding: var(--sp-4) var(--sp-6);
    border: 1px var(--shade6) solid;
    border-top: 3px transparent solid;
    border-left-color: transparent;
    cursor: pointer;

    @container tabs (inline-size <= 500px) {
      padding: var(--sp-2) var(--sp-4);
    }
    @container tabs (inline-size <= 400px) {
      flex-direction: column;
    }

    > * {
      pointer-events: none;
    }

    &:first-of-type {
      border-radius: var(--br-lg) 0 0 0;
    }

    &:last-of-type {
      border-radius: 0 var(--br-lg) 0 0;
      border-right: none;
    }

    &.selected {
      background: var(--shade7);
      box-shadow: inset 0 3px var(--turq);
      border-bottom: none;
      cursor: auto;

      .title {
        color: var(--shade0);
      }
    }

    .title {
      color: var(--shade0-75);
    }
    .score {
      color: var(--perf-color, var(--shade0));
    }
  }
`;

export const RankComparison = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--sp-1);

  &::before,
  &::after {
    content: "";
    height: 1px;
    flex: 1;
    background: var(--shade1-15);
  }
  &::before {
    margin-inline-end: var(--sp-3);
  }
  &::after {
    margin-inline-start: var(--sp-3);
  }

  svg {
    width: var(--sp-6);
    height: var(--sp-6);
  }
  .vs {
    color: var(--shade1);
  }

  .selectButton {
    margin-inline: var(--sp-1);
  }
`;

export const TabContent = styled("div")`
  display: grid;
  gap: var(--sp-4);
  background: var(--shade7);
  padding: var(--sp-6);
  border-radius: 0 0 var(--br-lg) var(--br-lg);

  .controls {
    display: flex;
    gap: var(--sp-8);

    /* &[data-hide-btns="true"] {
      .button-group {
        opacity: 0;
        visibility: hidden;
      }
    } */

    .button-group {
      flex: 1;
    }
  }

  .chart-container {
    position: relative;
  }
  .chart-description {
    text-align: center;
    padding-block: var(--sp-1);
    color: var(--shade2);
  }
`;
